import React, { useEffect, useState } from "react";

import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";
import ProductoFotos from "../../Productos/ProductoFotos";
import { request } from "../../../utils/request";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import Select from "react-select";

const Sucursales = () => {

    const [sucursales, setSucursales] = useState({});
    const [sucursal, setSucursal] = useState({});
    const [links, setLinks] = useState({});
    const [meta, setMeta] = useState({});
    const [filtros, setFiltros] = useState({});
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showFotos, setShowFotos] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      getSucursales();
    }, []);

	const getSucursales = async (url = null) => {
		url = url ? url : "sucursales?limit=10";
		const sucursales = await request(url);

		if (sucursales.data) {
			setSucursales(sucursales.data);
			setLinks(sucursales.links || {});
			setMeta(sucursales.meta || {});
            setLoading(false);
		}
	};
	const toggleCreateModal = () => {
        setShowCreate(prev => !prev);
        setSucursal({});
	};
	const toggleEditModal = (sucursal) => {
        setShowEdit(prev => !prev);
        setSucursal(sucursal);
	};
	const toggleFotosModal = (sucursal) => {
        setShowFotos(prev => !prev);
        setSucursal(sucursal);
	};
    // El debounce estaba sobre el handler y se reconstruía en cada render, así
    // que no agrupaba nada y el callback leía el `filtros` de su propio render:
    // dos cambios seguidos se pisaban. El filtro entra al estado de inmediato y
    // lo que espera es la petición.
    const onFiltroChange = (value, filtro) =>
        setFiltros((previos) => ({ ...previos, [filtro]: value }));

    useDebouncedEffect(() => {
        const query = Object.keys(filtros).map((fil) => {
            return `${fil}=${filtros[fil]}`;
        });

        getSucursales("sucursales?limit=10&" + query.join("&"));
    }, [filtros]);

    return (
        <div>
            <div className="page-header">
                <Link to={getLink("/configuracion/")}>
                    &laquo; Volver a configuración
                </Link>
                <h1 className="page-title row">
                    <span className="col">Sucursales</span>
                    <button
                        className="au-btn au-btn-icon au-btn--green au-btn--small"
                        onClick={toggleCreateModal}
                    >
                        <i className="zmdi zmdi-plus" />
                        Añadir Sucursal
                    </button>
                </h1>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col'>
                                <label htmlFor='search'>Buscar</label>
                                <input
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.target.value,
                                            "buscar"
                                        )
                                    }
                                    type='search'
                                    placeholder='Buscar...'
                                    className='form-control'
                                    name='buscar'
                                />
                            </div>
                            <div className='col-md-2'>
                                <label htmlFor='periodo'>Tipo</label>
                                <Select
                                    name='tipo'
                                    id='tipo'
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.value,
                                            "tipo"
                                        )
                                    }
                                    options={[
                                        {label: 'Todos', value: 'todos'},
                                        {label: 'General', value: 'general'},
                                        {label: 'Educativa', value: 'educativa'},
                                        {label: 'Almacén', value: 'almacen'},
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div>
                        {loading && <Loader />}
                        {!sucursales.length ? (
                            <div>
                                {!loading && (
                                    <div>
                                        Todavía no hay categorías creadas.
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="table-data">
                                <table className="table table-data2">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Nombre</th>
                                            <th>Dirección</th>
                                            <th>Tipo</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sucursales.map((sucursal) => (
                                            <tr
                                                className="tr-shadow"
                                                key={sucursal.id}
                                            >
                                                <td className="text-center">{sucursal.logo ? (
                                                    <button
                                                        title="Ver Logo"
                                                        onClick={() =>
                                                            toggleFotosModal(
                                                                sucursal
                                                            )
                                                        }
                                                        className="item"
                                                    >
                                                        <img src={sucursal.logo[0].url} alt={sucursal.nombre} style={{height: '40px', width: 'auto'}}/>
                                                    </button>
                                                ) : ''}</td>
                                                <td>
                                                    <Link
                                                        to={getLink(
                                                            `/sucursales/${sucursal.id}/editar`
                                                        )}
                                                        className="item"
                                                    >
                                                    {sucursal.nombre}
                                                    </Link>
                                                </td>
                                                <td>
                                                    {sucursal.direccion}
                                                </td>
                                                <td>{sucursal.tipo}</td>
                                                <td>
                                                    <div className="table-data-feature">
                                                        <Link
                                                            to={getLink(
                                                                `/sucursales/${sucursal.id}/editar`
                                                            )}
                                                            className="item"
                                                        >
                                                            <i className="zmdi zmdi-edit" />
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {links && (
                                    <Pagination
                                        links={links}
                                        meta={meta}
                                        getData={getSucursales}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Modal
                show={showCreate}
                blank={true}
                toggle={toggleCreateModal}
            >
                <Create
                    toggle={toggleCreateModal}
                    sucursal={sucursal}
                    sucursales={sucursales}
                    getSucursales={getSucursales}
                />
            </Modal>
            <Modal
                show={showEdit}
                blank={true}
                toggle={() => toggleEditModal({})}
            >
                <Edit
                    toggle={() => toggleEditModal({})}
                    sucursal={sucursal}
                    sucursales={sucursales}
                    getSucursales={getSucursales}
                />
            </Modal>
            {sucursal?.logo && (
                <Modal
                    show={showFotos}
                    blank={true}
                    toggle={() => {
                        setShowFotos(prev => !prev);
                    }}
                >
                    <ProductoFotos
                        toggle={() => {
                            setShowFotos(prev => !prev);
                        }}
                        fotos={sucursal.logo.map(
                            (foto) => foto.url
                        )}
                    />
                </Modal>
            )}
        </div>
    );
}

export default Sucursales;
